import DailyIframe from '@daily-co/daily-js'
import { once } from 'lodash'

export const useSupportedBrowser = once(() => {
  return DailyIframe.supportedBrowser()
})
